'use client'
import React from 'react'
import parse from 'html-react-parser';
import tailwindConfig from '@tailwind.config'


const AgentDescription = ({ html }) => {
    const style = {
        color: tailwindConfig.theme.extend.colors.secondary,
    };

    return (
        <div style={style}>
            {parse(`${html}`)}
        </div>
    );
};

export default AgentDescription;